import React from "react";

export const Contact = () => {
  const contactInfo = {
    areas:
      "Available to clients throughout Pennsylvania, Massachusetts, and in all PSYPACT states via telehealth.",
    phone: "617-982-2984",
    email: "elana@ekpsychology.com",
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="section-title text-center">
            <h2>Get In Touch</h2>
            <p>
              I welcome your inquiries and am happy to discuss whether my
              practice might be a good fit for your needs.
            </p>
          </div>

          <div className="row">
            <div className="col-md-8 col-md-offset-2 contact-info text-center">
              <div className="contact-item">
                <h3>Contact Information</h3>
                <p>
                  <span>
                    <i className="fa fa-map-marker"></i> Areas Served
                  </span>
                  {contactInfo.areas}
                </p>
              </div>

              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-phone"></i> Phone
                  </span>{" "}
                  <a href={`tel:${contactInfo.phone.replace(/-/g, "")}`}>
                    {contactInfo.phone}
                  </a>
                </p>
                <p className="contact-description">
                  Call for a free 15-minute consultation or to schedule an
                  appointment.
                </p>
              </div>

              <div className="contact-item">
                <p>
                  <span>
                    <i className="fa fa-envelope-o"></i> Email
                  </span>{" "}
                  <a href={`mailto:${contactInfo.email}`}>
                    {contactInfo.email}
                  </a>
                </p>
                <p className="contact-description">
                  Feel free to email with questions about my practice or to
                  request a consultation.
                </p>
              </div>

              <div className="contact-item">
                <h4>Initial Consultations</h4>
                <p>
                  I offer a complimentary 15-minute phone consultation to
                  discuss your concerns and determine if my approach is the
                  right fit for your needs. Please reach out via phone or email
                  to schedule this initial conversation.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>&copy; {new Date().getFullYear()} Elana Kagan Psychology</p>
        </div>
      </div>
    </div>
  );
};
